import _ from 'underscore';
import { useCallback, useState, useMemo, useEffect } from 'react';
import {
  CSMLSortBy, getSortingOptions,
} from '../../../model';

export const useSortByState = ({
  logger,
  i18n,
  handleUsage,
  userPreference,
}) => {
  const [sortBy, setSortBy] = useState(() => {
    if (userPreference && userPreference.sortBy) {
      return userPreference.sortBy;
    }
    return CSMLSortBy.MostRecent;
  });

  useEffect(() => {
    if (userPreference && userPreference.sortBy) {
      setSortBy(userPreference.sortBy);
    }
  }, [setSortBy, userPreference]);

  const sortingOptions = useMemo(
    () => getSortingOptions(i18n),
    [i18n]
  );

  const safeSetSortBy = useCallback((newVal) => {
    const allSortByOptions = Object.values(CSMLSortBy);
    let safeNewValue = CSMLSortBy.MostRecent; // default value
    if (_.contains(allSortByOptions, newVal)) {
      safeNewValue = newVal;
    }
    setSortBy(safeNewValue);
    return safeNewValue;
  }, []);

  const onSortByChange = useCallback((_evt, item) => {
    if (item) {
      const newVal = safeSetSortBy(item.key);
      logger.logTrace('onSortByChange', { sortby: newVal });
      if (userPreference) {
        // save preferences
        userPreference.setSortBy(newVal);
      }
      if (handleUsage) {
        handleUsage();
      }
    } else {
      // shouldn't happen
      logger.logError('onSortByChange, invalid key');
    }
  }, [safeSetSortBy, logger, userPreference, handleUsage]);

  return {
    sortBy,
    sortingOptions,
    setSortBy: safeSetSortBy,
    onSortByChange,
  };
};

